var acwhSlider = acwhSlider || {};

if (!Object.create) {
    Object.create = (function () {
        function F() {}

        return function (o) {
            if (arguments.length != 1) {
                throw new Error('Object.create implementation only accepts one parameter.');
            }
            F.prototype = o;
            return new F()
        }
    })()
}

jQuery(function ( $ ) {
 
    $.fn.whSlider = function( options ) {
        return this.each(function() {
            var whSlider = Object.create(acwhSlider.whSlider);
            whSlider.init(this, options);
        });
    };

    $.fn.whSlider.options = {
        sectionScroll: false,
        scrollParent: false
     };

    acwhSlider.whSlider = {
        
        init (elem, options) {
            var self = this;
            self.$container = $(elem);
            self.options = $.extend({}, $.fn.showHide.options, options);
            
            // Slider
            self.$slider = self.$container.find(".wh-slider");
            self.$slide = self.$slider.find(".wh-slider__slide");
            self.$prev = self.$container.find(".wh-slider__arrow--prev");
            self.$next = self.$container.find(".wh-slider__arrow--next");

            // Images 
            self.$imgWrap = self.$container.find(".wh-img__inner");
            self.$Image = self.$container.find(".wh-img__img");
            self.$newImage = self.$container.find(".wh-img__img--new");
            
            self.bindElements();
        },

        bindElements () {
            var self = this;

            var whSliderPoint = self.$container.waypoint(function(direction) {
                self.$container.addClass("animate-all")
                this.destroy();

            }, {
                offset: '20%'
            });
            

             self.$slide.each(function(i,v) {
                var image = new Image();
                    image.src = $(v).data("image");
            });
            self.$slider.on("beforeChange", function(event, slick, currentSlide, nextSlide) {

                var image = $(slick.$slides[nextSlide]).data("image");
                self.$imgWrap.addClass("hide-image");
                self.$newImage.attr("src", image ).addClass("show-new");
                self.$next.prop("disabled", true)
                self.$prev.prop("disabled", true)
            });

            self.$slider.on("afterChange", function(event, slick, currentSlide) {
                var image = $(slick.$slides[currentSlide]).data("image");
                
                setTimeout(function() {
                    self.$imgWrap.removeClass("hide-image hide-out");
                    self.$Image.addClass("wh-img__img--new hide-old");
                    self.$newImage.removeClass("wh-img__img--new show-new")
                    
                    self.$Image = self.$container.find(".wh-img__img");
                    self.$newImage = self.$container.find(".wh-img__img--new");

                }, 400);

                setTimeout( function() {
                    self.$Image.removeClass("hide-old");
                    self.$next.attr("disabled", false);
                    self.$prev.prop("disabled", false)
                }, 800);
                
            });
            
            self.$next.on("click", function() {
                self.$slider.slick("slickNext");
            });

            self.$prev.on("click", function() {
                self.$slider.slick("slickPrev");
            });

            self.$slider.slick({
                dots: true,
                arrows: false,
                fade: true,
                speed:400
            })

        } 
    }
});
